import { useId } from "react";

/**
 * An illustrated wide mouth jar of Karijeeva cold pressed coconut oil.
 * Drawn in SVG on purpose: no stock photo pretending to be our farm.
 *
 * state: "liquid" (water clear, pale gold) or "solid" (white, below about
 * 24°C, with a spoon scoop in the top: the reason we pack in jars).
 */
const BODY = "M40 104 h220 a30 30 0 0 1 30 30 v176 a36 36 0 0 1 -36 36 h-208 a36 36 0 0 1 -36 -36 v-176 a30 30 0 0 1 30 -30 z";

export default function Jar({ state = "liquid", className = "", label = true, title = "Karijeeva cold pressed coconut oil in a jar" }) {
  const id = useId().replace(/:/g, "");
  const solid = state === "solid";
  return (
    <svg viewBox="0 0 300 360" className={className} role="img" aria-label={title}>
      <defs>
        <linearGradient id={`glass-${id}`} x1="0" x2="1">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.2" />
          <stop offset="0.16" stopColor="#ffffff" stopOpacity="0.05" />
          <stop offset="0.84" stopColor="#ffffff" stopOpacity="0.04" />
          <stop offset="1" stopColor="#ffffff" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient id={`oil-${id}`} x1="0" y1="0" x2="0" y2="1">
          {solid ? (
            <>
              <stop offset="0" stopColor="#FFFFFF" />
              <stop offset="1" stopColor="#ECE9E1" />
            </>
          ) : (
            <>
              <stop offset="0" stopColor="#FFF6D6" stopOpacity="0.6" />
              <stop offset="1" stopColor="#E9C46A" stopOpacity="0.78" />
            </>
          )}
        </linearGradient>
        <radialGradient id={`glow-${id}`} cx="0.5" cy="0.62" r="0.62">
          <stop offset="0" stopColor="#E9C46A" stopOpacity={solid ? 0 : 0.35} />
          <stop offset="1" stopColor="#E9C46A" stopOpacity="0" />
        </radialGradient>
        <clipPath id={`body-${id}`}><path d={BODY} /></clipPath>
      </defs>

      <ellipse cx="150" cy="220" rx="170" ry="150" fill={`url(#glow-${id})`} />

      {/* oil, filled to just below the shoulder */}
      <g clipPath={`url(#body-${id})`}>
        <rect x="0" y="128" width="300" height="240" fill={`url(#oil-${id})`} />
        {solid ? (
          <path d="M150 128 m-46 0 a46 16 0 0 0 92 0 z" fill="#DCD8CD" opacity="0.9" />
        ) : (
          <rect x="0" y="128" width="300" height="3" fill="#FFF8E1" opacity="0.85" />
        )}
      </g>

      {/* glass body and neck */}
      <path d={BODY} fill={`url(#glass-${id})`} stroke="#ffffff" strokeOpacity="0.38" strokeWidth="1.6" />
      <rect x="46" y="86" width="208" height="22" rx="6" fill="#ffffff" fillOpacity="0.08" stroke="#ffffff" strokeOpacity="0.3" />
      <path d="M34 150 v150" stroke="#ffffff" strokeOpacity="0.35" strokeWidth="7" strokeLinecap="round" />

      {/* wide lid with grip ridges */}
      <rect x="38" y="30" width="224" height="60" rx="10" fill="#1A1A18" />
      <rect x="38" y="30" width="224" height="11" rx="5.5" fill="#2C2C29" />
      {Array.from({ length: 21 }, (_, i) => (
        <line key={i} x1={50 + i * 10} y1="48" x2={50 + i * 10} y2="84" stroke="#000" strokeOpacity="0.35" strokeWidth="2" />
      ))}

      {label && (
        <g>
          <rect x="62" y="170" width="176" height="118" rx="5" fill="#0B0B0A" opacity="0.92" />
          <text x="150" y="214" textAnchor="middle" fill="#F5F5F2" fontFamily="Inter Tight, sans-serif" fontWeight="600" fontSize="24" letterSpacing="-0.5">Karijeeva</text>
          <text x="150" y="236" textAnchor="middle" fill="#F5F5F2" fillOpacity="0.7" fontFamily="Inter Tight, sans-serif" fontSize="10" letterSpacing="1.6">COLD PRESSED</text>
          <text x="150" y="250" textAnchor="middle" fill="#F5F5F2" fillOpacity="0.7" fontFamily="Inter Tight, sans-serif" fontSize="10" letterSpacing="1.6">COCONUT OIL</text>
          <line x1="126" y1="262" x2="174" y2="262" stroke="#2E7D4F" strokeWidth="2" />
          <text x="150" y="279" textAnchor="middle" fill="#F5F5F2" fillOpacity="0.55" fontFamily="Inter Tight, sans-serif" fontSize="9" letterSpacing="1.2">KARNATAKA</text>
        </g>
      )}
    </svg>
  );
}
